import ActionButton from '@/components/buttons/ActionButton';
import { useCopyToClipboard } from '@/hooks';
import { CopyToClipboardButtonProps } from './types';

const CopyToClipboardButton = ({
  label,
  notifyProps,
  onCopied,
  renderIcon = true,
  textToCopy,
}: CopyToClipboardButtonProps) => {
  const { copyToClipboard } = useCopyToClipboard();

  return (
    <ActionButton
      iconType="fileCopy"
      label={label}
      onClick={() => copyToClipboard({ notifyProps, onCopied, textToCopy })}
      renderIcon={renderIcon}
    />
  );
};

export default CopyToClipboardButton;
